import { jsx as _jsx } from "react/jsx-runtime";
const HorizontalLoader = (props) => {
    if (props.mode === 'infinite') {
        return (_jsx("div", { className: `relative h-2 w-full overflow-hidden rounded-full bg-gray-200 ${props.className}`, children: _jsx("div", { className: "animate-infinite-loader absolute top-0 h-full bg-blue-500" }) }));
    }
    // Controlled mode: width is based on the progress prop with smooth transition.
    return (_jsx("div", { className: `h-2 w-full rounded-full bg-gray-200 ${props.className}`, children: _jsx("div", { className: "h-2 rounded-full bg-blue-500 transition-all duration-300", style: { width: `${props.progress}%` } }) }));
};
export default HorizontalLoader;
